import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LoginRequest } from '../modelos/login-request/login-request';
import { LoginResponse } from '../modelos/login-response/login-response';
import { RegisterRequest } from '../modelos/register-request/register-request';
import { environment } from '../../../environments/environment.development';
import { SocketService } from './shoket.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private usuarioSubject = new BehaviorSubject<any>(this.obtenerUsuarioLocal());
  private obtenerUsuarioLocal(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
  usuario$ = this.usuarioSubject.asObservable();

  constructor(
    private http: HttpClient,
    private socketService: SocketService,
  ) {}

  register(data: RegisterRequest) {
    return this.http.post(`${environment.apiUrl}/auth/register`, data);
  }

  login(data: LoginRequest) {
    return this.http.post<LoginResponse>(`${environment.apiUrl}/auth/login`, data);
  }

  isLogged() {
    return !!localStorage.getItem('token');
  }

  logout(): void {
    this.socketService.disconnect();
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    this.usuarioSubject.next(null);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser() {
    return this.usuarioSubject.value;
  }

  /**
   * Actualiza parcialmente el usuario.
   * Útil cuando se modifica solo nombre, apellido, etc.
   */
  actualizarUsuarioLocal(datos: any): void {
    const usuarioActual = this.getUser();

    if (!usuarioActual) {
      return;
    }

    const usuarioActualizado = {
      ...usuarioActual,
      ...datos,
    };

    localStorage.setItem('user', JSON.stringify(usuarioActualizado));

    this.usuarioSubject.next(usuarioActualizado);
  }

  /**
   * Reemplaza el usuario completo.
   * Útil cuando obtenemos nuevamente el usuario desde el backend.
   */
  actualizarUsuarioCompleto(usuario: any): void {
    localStorage.setItem('user', JSON.stringify(usuario));

    this.usuarioSubject.next(usuario);
  }

  getRol() {
    return this.getUser()?.rol;
  }

  getClinica() {
    return this.getUser()?.clinica;
  }

  verificarCorreo(token: string) {
    return this.http.get<{ message: string }>(`${environment.apiUrl}/auth/verificar-correo`, {
      params: { token },
    });
  }

  recuperarPassword(email: string){
    return this.http.post<{message: string}>(`${environment.apiUrl}/auth/forgot-password`,{ email })
  }
  cambiarPassword(password: string, token: string){
    return this.http.post<{message: string}>(`${environment.apiUrl}/auth/change-password`,{ password, token })
  }
}
